export default {
  default: () => import("/vercel/path0/apps/main/layouts/default.vue").then(m => m.default || m)
}